/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ReprocessPaymentResultViewModel } from "../types/ReprocessPaymentResultViewModel.ts";

export const reprocessPaymentResultViewModelSchema = z.object({
  success: z.optional(z.boolean()),
  status: z.string().nullish(),
  orderId: z.string().nullish(),
  lastCreditCardPaymentId: z.optional(z.number().int()),
  message: z.string().nullish(),
}) as unknown as ToZod<ReprocessPaymentResultViewModel>;
